import styled, { css } from 'styled-components'

import { _XS_Medium, _XS_Normal, mainColors } from '@avantstay/backoffice-core'

import {
  dateCellWidthVar,
  firstColumnWidthVar,
  propertyRowHeightVar,
} from '@new/domains/fastBookingsTapeChart/config/styles'

import { minifyXml } from './__utils'

export const todayBorder = (left: string, isHeader = false) => css`
  &::after {
    position: absolute;
    content: '';
    z-index: 1;
    left: ${left};
    bottom: -${isHeader ? 1 : 0}px;
    top: 0;
    pointer-events: none;
    background-color: ${mainColors.accentLight};
    width: 2px;
  }
`

export const DateCell = styled.div`
  width: ${dateCellWidthVar.get()};
`

export const Row = styled.div<{ selected?: boolean }>`
  display: flex;
  min-height: ${propertyRowHeightVar.get()};
`

export const FirstColumnCell = styled.div`
  width: ${firstColumnWidthVar.get()};
  position: sticky;
  left: 0;
  flex-shrink: 0;
`

export const ExtendedColumnCell = styled.div<{
  width: number
  color?: string
  isClickable?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => `${width}px`};
  height: 100%;
  ${_XS_Normal};
  color: ${({ color }) => (color ? color : mainColors.neutralExtremelyDark)};
  gap: 4px;
  ${({ isClickable }) => (isClickable ? 'cursor: pointer' : undefined)};

  svg {
    max-width: 16px;
    max-height: 16px;
    min-width: 16px;
    min-height: 16px;
    color: ${({ color }) => (color ? color : mainColors.neutralExtraDark)};
  }
`

export const ExtendedHeaderCell = styled(ExtendedColumnCell)<{ $iconColor?: string }>`
  position: relative;
  gap: 6px;
  ${_XS_Medium};

  svg {
    max-width: 24px;
    max-height: 24px;
    min-width: 24px;
    min-height: 24px;
    color: ${({ $iconColor }) => $iconColor};
  }
`

export const ExtendedHeaderGroupCell = styled(ExtendedColumnCell)`
  position: relative;
  gap: 6px;
`

export const getHighlightingBackground = (color: string) => {
  const svg = minifyXml(`
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="1" clip-path="url(#clip0_2_773)">
            <path d="M46 -26L-19 39" stroke="${color}" stroke-width="6"/>
            <path d="M30 -26L-35 39" stroke="${color}" stroke-width="6"/>
        </g>
        <defs>
            <clipPath id="clip0_2_773">
                <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0)"/>
            </clipPath>
        </defs>
      </svg>`)

  return `url('data:image/svg+xml;utf8,${encodeURIComponent(svg)}')`
}

export const Link = styled.a``
